import { businessUnits } from '../../businessUnitConfig';

export const extractBusinessUnit = (path: string) => {
  const firstPart = path.split('?')[0].split('/')[1].toUpperCase();
  const businessUnit = Object.keys(businessUnits).includes(firstPart) ? firstPart : 'unknown';

  const { language, country, filter, paths, links, iframe, currency, distanceUnit } = businessUnits[businessUnit] || {};
  const locale = `${language}-${country}`;

  return {
    businessUnits,
    businessUnit,
    language,
    country,
    locale,
    paths,
    links,
    filterCountriesIso3Codes: filter,
    iframe,
    currency,
    distanceUnit,
  };
};
